import { Button } from "@organizacaox/lai-design-system";
// Faixa "pagamento pendente" — topo do app, durante a carência.
//
// Ocupa o lugar da antiga faixa de ativação, e pelo mesmo motivo: um estado que
// a pessoa precisa entender antes de concluir que o produto quebrou. A
// diferença é que este tem prazo — vencidos os dias, o guard do back tranca a
// marca inteira (features/plans/guard.ts).
//
// O texto não carrega valor nem nome de plano, NEM para o gestor: assim o mesmo
// componente serve aos dois papéis sem virar dois. O que muda por papel é só o
// botão — vendedor não abre o Portal do Stripe porque não é ele quem paga.
import { useTranslation } from "react-i18next";
import "./i18n.js";
import { CreditCard } from "lucide-react";

import { useOpenBillingPortal, useSubscriptionAccess } from "@/hooks/use-plans";
import { useAccessSnapshot } from "@/hooks/use-viewer-role";

export function GraceBanner() {
  const { t } = useTranslation();
  const { baseRole } = useAccessSnapshot();
  const { data: assinatura } = useSubscriptionAccess();

  // A navegação saiu de dentro do `mutationFn` e virou `onSuccess`: é o que o
  // hook do domínio oferece e o que as outras três telas do Portal já faziam.
  const portal = useOpenBillingPortal({
    onSuccess: ({ url }) => {
      window.location.href = url;
    },
  });

  // Só a carência acende a faixa. Assinatura em dia, ausente ou já bloqueada
  // não têm o que avisar aqui: a ausente e a bloqueada são tratadas pelo degrau
  // de /subscription, que é uma tela inteira, não um aviso de topo.
  if (!assinatura || assinatura.status !== "past_due" || assinatura.graceDaysLeft == null) {
    return null;
  }

  const dias = assinatura.graceDaysLeft;
  const podePagar = baseRole === "director" || baseRole === "manager";

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b border-red-500/30 bg-red-500/10 px-4 py-2 text-center text-sm text-red-900 dark:text-red-200"
    >
      <span>
        <strong className="font-medium">{t("financial.grace.title")}</strong>{" "}
        {t("financial.grace.blockedIn", { count: dias })}
      </span>
      {podePagar ? (
        <Button
          variant="ghost"
          type="button"
          onClick={() => portal.mutate()}
          disabled={portal.isPending}
          className="h-auto whitespace-normal inline-flex items-center gap-1.5 font-medium underline underline-offset-2"
        >
          <CreditCard aria-hidden="true" className="size-3.5" />
          {t("financial.grace.action")}
        </Button>
      ) : null}
    </div>
  );
}
